import styled, {css} from 'styled-components'
import {ChipProps} from '@components/ui/chip/Chip.tsx'

const baseChipStyles = css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: default;
    user-select: none;
    transition: all 0.3s ease-in-out;
`

export const StyledChip = styled.div<
    ChipProps & {$isOnlyIcon?: boolean; $bgColor?: string; $textColor?: string; $doubleCircle?: boolean}
>`
    ${({$doubleCircle, $bgColor, $textColor, $isOnlyIcon, theme}) => css`
        ${baseChipStyles};
        gap: ${theme.spacing}px;
        padding: ${theme.spacing}px ${theme.spacing * 2}px;
        border-radius: ${$doubleCircle || $isOnlyIcon ? '50%' : '16px'};
        background-color: ${$bgColor || theme.palette.primary[100]};
        color: ${$textColor || theme.palette.primary[700]};
        ${theme.typography.textXs};
        display: flex;
        align-items: center;

        ${$isOnlyIcon &&
        css`
            width: 40px;
            height: 40px;
            padding: ${theme.spacing * 2.5}px;

            & svg {
                fill: transparent;
                stroke: ${$textColor || theme.palette.primary[600]};
                & path {
                    stroke: ${$textColor || theme.palette.primary[600]};
                }
            }
        `}

        ${$doubleCircle &&
        css`
            width: 30px;
            height: 30px;
            padding: ${theme.spacing * 4}px;
        `}
    `}
`

export const StyledContainerChip = styled.div<ChipProps & {$doubleCircle?: boolean}>`
    ${({$doubleCircle, theme}) => css`
        ${$doubleCircle &&
        css`
            background: ${theme.palette.primary[50]};
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50px;
            height: 50px;
            padding: ${theme.spacing}px;
        `}
    `}
`

export const DeleteButton = styled.button`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    border: none;
    background: none;

    &:hover {
        opacity: 0.7;
    }

    &:focus {
        outline: none;
    }
`
